import React from 'react';

import './DrawerToggleButton.css';

const DrawerToggleButton = props => {
    return (
        <div>
            <button className="toggle-button" aria-label="Open navigation menu" onClick={props.click}>
                <div className="toggle-button__line"></div>
                <div className="toggle-button__line"></div>
                <div className="toggle-button__line"></div>
            </button>
        </div>
    )
}

export default DrawerToggleButton;
